import { DelayedComponentLoader } from "@ch/components/Loaders/ComponentLoader/DelayedComponentLoader";
import { type FC, Suspense, lazy } from "react";

const HeartRateLogPage = lazy(() => import("./HeartRateLogPage"));

const HeartRateLogPageLazy: FC = () => {
  return (
    <Suspense fallback={<DelayedComponentLoader />}>
      <HeartRateLogPage />
    </Suspense>
  );
};

export default HeartRateLogPageLazy;
